export default __webpack_public_path__ + "static/top-innovator-2025-ff0c662e9704c20507fb80174af226dc.png";